import { ShoppingBag, ShieldCheck, PlayCircle, CreditCard, Star, Heart, Check } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const BeratungSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="beratung" data-testid="beratung-section" className="section-padding bg-stone-50" ref={sectionRef}>
      <div className="container-custom">
        <div className="text-center max-w-4xl mx-auto mb-20 reveal">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4">Der Jennifer Laak Service</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6 font-[Outfit]">
            Thermomix® Beratung in Krefeld – persönlich statt anonym
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Ein Thermomix® ist mehr als eine Küchenmaschine – er ist ein Partner für deine Gesundheit und dein Zeitmanagement. In Krefeld biete ich dir einen Service, den kein Algorithmus ersetzen kann.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-start reveal reveal-delay-1">
          {/* Left column */}
          <div className="space-y-8">
            <div className="glass-card rounded-[2rem] p-8 hover-lift">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-400 to-emerald-600 text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/20"><ShoppingBag className="w-7 h-7" /></div>
              <h4 className="text-xl font-bold mb-4 font-[Outfit]">Persönlicher Verkauf</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Wer im Internet kauft, bekommt ein Paket. Wer bei mir in Krefeld kauft, bekommt eine Einweisung, ein offenes Ohr und die Gewissheit, dass das Gerät optimal genutzt wird. Ich kümmere mich um den kompletten Bestellprozess, erkläre dir die Finanzierungsmöglichkeiten (0% Sonderteilzahlung) und sorge dafür, dass dein Start reibungslos verläuft.
              </p>
            </div>
            <div className="glass-card rounded-[2rem] p-8 hover-lift">
              <div className="w-14 h-14 bg-slate-900 text-white rounded-2xl flex items-center justify-center mb-6"><ShieldCheck className="w-7 h-7" /></div>
              <h4 className="text-xl font-bold mb-4 font-[Outfit]">After-Sales Support</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Fragen nach dem Kauf? In meiner exklusiven Kunden-WhatsApp-Gruppe für den Raum Krefeld tauschen wir uns aus. Ich teile dort Rezepte, saisonale Tipps und stehe bei technischen Fragen oder Unsicherheiten sofort parat. Du bist niemals allein mit deinem Multitalent.
              </p>
            </div>
          </div>

          {/* Center green banner */}
          <div className="hidden lg:flex flex-col items-center justify-center p-10 bg-emerald-600 rounded-[2rem] text-white shadow-2xl relative overflow-hidden h-full">
            <Star className="absolute -top-10 -right-10 w-40 h-40 text-white/10 rotate-12" />
            <Heart className="w-16 h-16 mb-8 text-white/20" />
            <h4 className="text-2xl font-bold mb-6 text-center font-[Outfit]">Warum Krefeld bei Jennifer kauft</h4>
            <ul className="space-y-4">
              {["Direkte Ansprechpartnerin vor Ort", "Kostenlose Einweisung zu Hause", "Zugang zu exklusiven Rezepten", "Hilfe bei Garantie & Reparatur", "Lokale Koch-Community"].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-sm font-bold">
                  <Check className="w-5 h-5 text-emerald-300 flex-shrink-0" /> {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Right column */}
          <div className="space-y-8">
            <div className="glass-card rounded-[2rem] p-8 hover-lift">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-400 to-emerald-600 text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/20"><PlayCircle className="w-7 h-7" /></div>
              <h4 className="text-xl font-bold mb-4 font-[Outfit]">Showkochen & Testen</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Du möchtest nicht die Katze im Sack kaufen? Kein Problem. Bei einem unverbindlichen Erlebniskochen in deiner eigenen Küche in Krefeld oder Umgebung zeige ich dir, was der TM7 wirklich kann. Wir kochen gemeinsam, du bedienst das Gerät selbst und überzeugst dich bei einem leckeren Menü von der Qualität und der Zeitersparnis.
              </p>
            </div>
            <div className="glass-card rounded-[2rem] p-8 hover-lift">
              <div className="w-14 h-14 bg-slate-900 text-white rounded-2xl flex items-center justify-center mb-6"><CreditCard className="w-7 h-7" /></div>
              <h4 className="text-xl font-bold mb-4 font-[Outfit]">Smarte Finanzierung</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Der Thermomix® soll in dein Budget passen. Ich berate dich transparent zu allen Zahlungsoptionen. Ob Sofortkauf, klassische Finanzierung oder die beliebten Sonderteilzins-Aktionen von Vorwerk – wir finden den Weg, der für dich am bequemsten ist, schon ab ca. 50 € im Monat.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeratungSection;
